import { connect } from 'react-redux';
import { IconButton, Paper, SvgIcon, TextField} from '@mui/material';
import React, { Component } from 'react';
import {
  AddStoreToDoorDelivertTime,
  GetAllStoreToDoorDelivertTime,
  deleteStoreToDoorDelivertTime,
  resetupdateStoreToDoorDelivertTimeState,
  updateStoreToDoorDelivertTime,
} from 'actions/EntityActions';
import { showSnackbar } from 'actions/CommonActions';
import LOOKUP from 'constants/lookup';

class StoretoDoorDeliveryWindow extends Component {
  constructor(props) {
    super(props);
    
    const hasDeliveryData = props.deliveryData && Object.keys(props.deliveryData).length > 0;
    this.state = {
      dayDeliveryTimeSelections: hasDeliveryData
        ? this.processDeliveryData(props.deliveryData)
        : this.initializedayDeliveryTimeSelections(),
      isWaitingForAddResponse: false,
      pendingDay: null
    };
    this.sectionRefs = [];
    this.handleTimeChange = this.handleTimeChange.bind(this);
  }

  dayToEnum = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
  };

  createEmptySlot = () => ({
    id: 0,
    openingHour: '',
    closingHour: '',
    maximumDelivery: 0
  });

  processDeliveryData = (deliveryData) => {
    const updatedData = JSON.parse(JSON.stringify(deliveryData));
 
    Object.keys(updatedData).forEach((day) => {
      if (!updatedData[day].timeSlots) {
        updatedData[day].timeSlots = [this.createEmptySlot()];
      } else {
        const sortedSlots = [...updatedData[day].timeSlots].sort((a, b) => {
          if (!a.id || a.id === 0) return -1;
          if (!b.id || b.id === 0) return 1;
          return a.id - b.id;
        });
 
        if (!sortedSlots.length || (sortedSlots[0].id !== 0 && sortedSlots[0].id !== null)) {
          sortedSlots.unshift(this.createEmptySlot());
        }
 
        updatedData[day].timeSlots = sortedSlots;
      }
    });
    return updatedData;
  }; 

  initializedayDeliveryTimeSelections = () => {
    var model = {
      branchId: this.props.branchId
    };
    this.props.getAllStoreToDoorDelivery(model);

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return days.reduce((acc, day) => {
      acc[day] = {
        timeSlots: [this.createEmptySlot()],
      };
      return acc;
    }, {});
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  componentDidUpdate(prevProps) {
    if (this.props.deletedStoreLockDateNTimeFailed && (prevProps.deletedStoreLockDateNTimeFailed == undefined || prevProps.deletedStoreLockDateNTimeFailed !== this.props.deletedStoreLockDateNTimeFailed))
        this.props.showSnackbar(LOOKUP.StoreToDoor.messages.deleteErrorMessage); 

    if (prevProps.deliveryData !== this.props.deliveryData) {
      const { pendingDay } = this.state;

     if (this.props.updatedStoreLockDateNTimeSuccess && ( prevProps.updatedStoreLockDateNTimeSuccess == undefined || prevProps.updatedStoreLockDateNTimeSuccess !== this.props.updatedStoreLockDateNTimeSuccess))
     {
      this.props.showSnackbar(LOOKUP.StoreToDoor.messages.editedMessage); 
      this.props.resetupdateStoreToDoorDelivertTimeState();
     }

     if(this.props.createStoreToDoorSuccess && prevProps.createStoreToDoorSuccess !== this.props.createStoreToDoorSuccess){
      this.props.showSnackbar(LOOKUP.StoreToDoor.messages.createdMessage);
    }

    if(this.props.deletedStoreLockDateNTimeSuccess && prevProps.deletedStoreLockDateNTimeSuccess !== this.props.deletedStoreLockDateNTimeSuccess){
      this.props.showSnackbar(LOOKUP.StoreToDoor.messages.deleteMessage);
    }

      if (this.state.isWaitingForAddResponse && !this.props.createStoreToDoorFailed) {
        const updatedData = {
          ...this.state.dayDeliveryTimeSelections,
          [pendingDay]: {
            timeSlots: this.props.deliveryData[pendingDay].timeSlots
          }
        };
        
        this.setState({
          dayDeliveryTimeSelections: this.processDeliveryData(updatedData),
          isWaitingForAddResponse: false,
          pendingDay: null
        });
      } else {
        this.setState({
          dayDeliveryTimeSelections: this.processDeliveryData(
            this.props.deliveryData || this.initializedayDeliveryTimeSelections()
          )
        });
      }
    }

    if (this.props.updatedStoreDeliveryDateTimeFailed && ( prevProps.updatedStoreDeliveryDateTimeFailed == undefined ||  prevProps.updatedStoreDeliveryDateTimeFailed !== this.props.updatedStoreDeliveryDateTimeFailed)) 
       this.props.showSnackbar(this.props.updatedStoreDeliveryDateTimeMessageFailed); 

    if (this.props.createStoreToDoorFailed && prevProps.createStoreToDoorFailed !== this.props.createStoreToDoorFailed) {
      this.props.showSnackbar(this.props.createStoreToDoorMessageFailed);  
      
      const { pendingDay } = this.state;
      if (pendingDay) {
        this.setState(prevState => ({
          dayDeliveryTimeSelections: {
            ...prevState.dayDeliveryTimeSelections,
            [pendingDay]: {
              timeSlots: [this.createEmptySlot(), ...prevState.dayDeliveryTimeSelections[pendingDay].timeSlots.slice(1)]
            }
          },
          isWaitingForAddResponse: false,
          pendingDay: null
        }));
      }
    }
  }

  handleTimeChange = (e, day, index, timeType) => {
    const { value } = e.target;
    this.setState((prevState) => {
      const updatedTimeSlots = prevState.dayDeliveryTimeSelections[day].timeSlots.map((slot, i) => {
        if (i === index) {
          return { ...slot, [timeType]: value };
        }
        return slot;
      });

      return {
        dayDeliveryTimeSelections: {
          ...prevState.dayDeliveryTimeSelections,
          [day]: {
            ...prevState.dayDeliveryTimeSelections[day],
            timeSlots: updatedTimeSlots,
          },
        },
      };
    });
  };

  convertTo24Hour = (time) => {
    const [hours, minutesPeriod] = time.split(':');
    const [minutes, period] = minutesPeriod.split(' ');
    let h = parseInt(hours, 10);
    if (period === 'PM' && h < 12) h += 12;
    if (period === 'AM' && h === 12) h = 0;
    return `${h < 10 ? '0' + h : h}:${minutes}:00`;
  };

  timeToMinutes = (time) => {
    const [hours, minutes] = time.split(':');
    return parseInt(hours, 10) * 60 + parseInt(minutes, 10);
  };

  handleMaximumDeliveryChange = (e, day, idx) => {
    let newValue = e.target.value;
    this.setState((prevState) => {
      const updatedDayDeliveryTimeSelections = { ...prevState.dayDeliveryTimeSelections };
      updatedDayDeliveryTimeSelections[day].timeSlots[idx].maximumDelivery = newValue;
      return {
        dayDeliveryTimeSelections: updatedDayDeliveryTimeSelections,
      };
    });
  };

  addNewRow = (day) => {
    const dayData = this.state.dayDeliveryTimeSelections[day];
    const { timeSlots } = dayData;
    const { AddStoreToDoorDelivertTime, branchId, showSnackbar } = this.props;
    const firstSlot = timeSlots[0];
    if (firstSlot && firstSlot.openingHour && firstSlot.closingHour) {
      const opening24Hour = this.convertTo24Hour(firstSlot.openingHour);
      const closing24Hour = this.convertTo24Hour(firstSlot.closingHour);

      const openingMinutes = this.timeToMinutes(opening24Hour);
      const closingMinutes = this.timeToMinutes(closing24Hour);

      if (closingMinutes <= openingMinutes) {
        showSnackbar("Error! Closing time cannot be earlier than or equal to opening time.");
        return;
      }
      
      if (firstSlot.maximumDelivery === undefined || firstSlot.maximumDelivery < 1
         || firstSlot.maximumDelivery > 1000 || (firstSlot.maximumDelivery % 1 !== 0)) {
          this.props.showSnackbar("MaximumDeliveries is not Valid!");
        return;
      }

      const createStoreToDoorDeliveryModel = {
        Weekday: this.dayToEnum[day],
        BranchId: branchId,
        timeSlots: [{
          openingHour: firstSlot.openingHour,
          closingHour: firstSlot.closingHour,
          MaximumDelivery: firstSlot.maximumDelivery || 0,
        }]
      };

      AddStoreToDoorDelivertTime(createStoreToDoorDeliveryModel);
      this.setState({ isWaitingForAddResponse: true, pendingDay: day });
    } else {
      showSnackbar("Please fill both Open Time and Close Time before submit");
    }
  };

  editRow = (day, index, id, openingHour, closingHour, maximumDelivery ) => {
    const { branchId } = this.props;
    const updatedTimeSlots = this.state.dayDeliveryTimeSelections[day].timeSlots.filter((_, i) => i !== index);

    if (index === 0 || updatedTimeSlots.length === 0 || updatedTimeSlots[0].id !== 0) {
      updatedTimeSlots.unshift(this.createEmptySlot());
    }
    if (maximumDelivery === undefined || maximumDelivery < 1
      || maximumDelivery > 1000 || maximumDelivery % 1 !== 0) {
        this.props.showSnackbar("MaximumDeliveries is not Valid!");
     return;
   }

    const sortedSlots = updatedTimeSlots.sort((a, b) => {
      if (!a.id || a.id === 0) return -1;
      if (!b.id || b.id === 0) return 1;
      return a.id - b.id;
    });

    if (id !== 0 && id !== null) {
      const updateStoreToDoorDeliveryModel = {
        Weekday: this.dayToEnum[day],
        BranchId: branchId,
        timeSlots: [{
          id: id,
          openingHour: openingHour,
          closingHour: closingHour,
          MaximumDelivery: maximumDelivery 
        }]
      };

      this.props.updateStoreToDoorDelivertTime(updateStoreToDoorDeliveryModel);
      this.setState({ isWaitingForAddResponse: true, pendingDay: day });
    }
  };

  deleteRow = (day, index, id) => {
    const updatedTimeSlots = this.state.dayDeliveryTimeSelections[day].timeSlots.filter((_, i) => i !== index);

    if( id == null || id == undefined){
      this.props.showSnackbar("please refresh page and try again!");
      return;
    }

    if (index === 0 || updatedTimeSlots.length === 0 || updatedTimeSlots[0].id !== 0) {
      updatedTimeSlots.unshift(this.createEmptySlot());
    }

    const sortedSlots = updatedTimeSlots.sort((a, b) => {
      if (!a.id || a.id === 0) return -1;
      if (!b.id || b.id === 0) return 1;
      return a.id - b.id;
    });

    this.setState((prevState) => ({
      dayDeliveryTimeSelections: {
        ...prevState.dayDeliveryTimeSelections,
        [day]: {
          ...prevState.dayDeliveryTimeSelections[day],
          timeSlots: sortedSlots,
        },
      },
    }));

    if (id !== 0 && id !== null) {
      const model = { Id: id };
      this.props.deleteStoreToDoorDelivertTime(model);
    }
  };

  render() {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const timeOptions = Array.from({ length: 24 * 4 }, (_, i) => {
      const hour = Math.floor(i / 4) % 12 || 12;
      const minute = (i % 4) * 15;
      const period = Math.floor(i / 48) === 0 ? 'AM' : 'PM';
      return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} ${period}`;
    });

    const { dayDeliveryTimeSelections } = this.state;

    return (
      <Paper style={{ padding: 16, minWidth: '720px', maxWidth: '720px', marginRight: 'auto' }}>
        <section
          className="StoreLockDateAndTime-header-container"
          style={{ borderBottom: '1px solid #c2b8e9' }}
        >
          <h3 style={{ marginTop: 0, fontWeight: '600', textAlign: 'center' }}>
            Store to Door Delivery Window Settings
          </h3>
          <h5
            style={{
              margin: 0,
              marginBottom: '5px',
              fontSize: '15px',
              textAlign: 'center',
            }}
          >
            Enable each delivery window time per day and add additional windows. Set your maximum
            deliveries per window.
          </h5>
        </section>

        <section
          className="StoreLockDateAndTime-body-container"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            justifyContent: 'space-between',
          }}
        >
          {days.map((day, index) => (
            <section
              key={day}
              style={{
                width: "100%",
                margin: "10px 0",
                padding: "10px",
                border: "1px solid #b0a6e3",
                boxSizing: "border-box",
                maxHeight: "300px",
                overflowY: "auto",
              }}
              ref={(ref) => {
                this.sectionRefs[index] = ref;
              }}
            >
              <div style={{ marginBottom: 20 }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    marginBottom: 20,
                  }}
                >     
                  <h4 style={{ margin: 0, width: '15%' }}>{day}</h4>
                  <h4 style={{ margin: 10, marginLeft: 238, width: '35%' }}>Maximum Delivery</h4>
                  <IconButton
                    style={{
                      borderRadius: '50%',
                      padding: 0,
                      border: '3px solid #8576d3',
                      width: '33px',
                      height: '33px',
                    }}
                    onClick={() => this.addNewRow(day)}
                  >
                    <SvgIcon style={{ width: '15px', height: '15px' }}>
                      <path fill="#8576d3" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                    </SvgIcon>
                  </IconButton>
                </div>
                {dayDeliveryTimeSelections[day].timeSlots &&
                  dayDeliveryTimeSelections[day].timeSlots.map((timeSlot, idx) => (
                    <section key={`${day}-${idx}`} style={{ height: '42px', width: '100%', margin: '10px 0' }}>
                      <div
                        style={{
                          height: '100%',
                          borderBottom: '1px solid #b0a6e3',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        <input type="hidden" value={timeSlot.id || ''} />
                        <section
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            minWidth: '35%',
                            alignItems: 'center',
                            backgroundColor: '#b0a6e3',
                            borderRadius: '10px',
                            marginBottom: '10px',
                          }}
                        >
                          <section style={{ display: 'flex', width: '100%', alignItems: 'center', marginLeft: '5px' }}>
                            <div
                              style={{
                                flex: 1,
                                paddingLeft: '2px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                height: '40px',
                                width: '100%',
                              }}
                            >
                              <select
                                value={timeSlot.openingHour}
                                onChange={(e) => this.handleTimeChange(e, day, idx, 'openingHour')}
                                style={{ marginRight: 10 }}
                              >
                                <option value="">Select Opening Hour</option>
                                {timeOptions.map((time) => (
                                  <option key={time} value={time}>
                                    {time}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </section>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              width: '8%'      
                            }}
                          >
                            <SvgIcon>
                              <path fill="#d1cde4" d="M12,2 L12,22 L22,12 L12,2 Z M2,12 L12,12 L12,14 L4,14 L4,10 L12,10 L12,12 L2,12 Z"></path>
                            </SvgIcon>
                          </div>
                          <section
                            style={{
                              display: 'flex',
                              width: '100%',
                              alignItems: 'center',
                              marginRight: '10px',
                            }}
                          >
                            <div
                              style={{
                                flex: 1,
                                paddingLeft: '5px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                height: '40px',
                                width: '100%',
                              }}
                            >
                              <select
                                value={timeSlot.closingHour}
                                onChange={(e) => this.handleTimeChange(e, day, idx, 'closingHour')}
                                style={{ marginRight: 10 }}
                              >
                                <option value="">Select Closing Hour</option>
                                {timeOptions.map((time) => (
                                  <option key={time} value={time}>
                                    {time}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </section>
                        </section>
                        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-1" style={{ marginLeft: '10px' }} >
                          <TextField
                            name={`maximumDelivery${day + idx}`}
                            type={'number'}
                            fullWidth={true}
                            value={timeSlot.maximumDelivery}
                            hintText="Maximum Deliveries"
                            inputProps={{ style: { height: '20px', padding: '5px' } }}
                            onChange={(e) => this.handleMaximumDeliveryChange(e, day, idx)}
                            style={{ height: '40px' }}
                          />
                        </div>
                        <IconButton
                            style={{
                              borderRadius: '50%',
                              padding: '0px',
                              border: '3px solid red',
                              width: '33px',
                              height: '33px',
                              marginLeft: '42px',
                              marginBottom: '12px',
                              display: 'flex', // Align children in center
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          onClick={() => this.deleteRow(day, idx, timeSlot.id)}
                        >
                          <SvgIcon style={{ width: '15px', height: '15px', position: 'relative', top: '2px', left: '2px'  }} >
                            <path     d="M18 4L4 18M4 4l14 14"
                              fill="none"
                              stroke="red"
                              strokeWidth="4" />
                          </SvgIcon>
                        </IconButton>
                        <IconButton
                          style={{
                            borderRadius: '50%',
                            padding: '0px',
                            border: '3px solid gray',
                            width: '33px',
                            height: '33px',
                            marginLeft: '22px',
                            marginBottom: '12px',
                          }}
                          onClick={() => this.editRow(day, idx, timeSlot.id, timeSlot.openingHour, timeSlot.closingHour, timeSlot.maximumDelivery)}
                        >
                          <SvgIcon style={{ width: '15px', height: '15px', color: 'red' }}>
                          <path fill="#b8abf1" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                          </SvgIcon>
                        </IconButton>
                      </div>
                    </section>
                  ))}
              </div>
              {index < days.length - 1 && <hr style={{ border: '1px solid #b0a6e3', margin: '-10px 0' }} />}
            </section>
          ))}
        </section>
      </Paper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
  storeLockDateAndTimeLists: state.entity.storeLockDateAndTimeLists,
  branchId: state.common.branchId,
  createStoreToDoorFailed: state.entity.createStoreToDoorFailed,
  createStoreToDoorMessageFailed: state.entity.createStoreToDoorMessageFailed,
  createStoreToDoorSuccess: state.entity.createdState,
  updatedStoreDeliveryDateTimeFailed: state.entity.updatedStoreDeliveryDateTimeFailed,
  updatedStoreDeliveryDateTimeMessageFailed: state.entity.updatedStoreDeliveryDateTimeMessageFailed,
  updatedStoreLockDateNTimeSuccess: state.entity.updatedStoreLockDateNTimeSuccess,
  deletedStoreLockDateNTimeFailed: state.entity.deletedStoreLockDateNTimeFailed,
  deletedStoreLockDateNTimeSuccess: state.entity.deletedState,
  deliveryData: state.entity.deliveryData
}};

function mapDispatchToProps(dispatch) {
  return {
    showSnackbar: (message) => dispatch(showSnackbar(message)),
    AddStoreToDoorDelivertTime: (model) => dispatch(AddStoreToDoorDelivertTime(model)),
    deleteStoreToDoorDelivertTime: (model) => dispatch(deleteStoreToDoorDelivertTime(model)),
    updateStoreToDoorDelivertTime: (model) => dispatch(updateStoreToDoorDelivertTime(model)),
    resetupdateStoreToDoorDelivertTimeState: () => dispatch(resetupdateStoreToDoorDelivertTimeState()),
    getAllStoreToDoorDelivery: (model) => dispatch(GetAllStoreToDoorDelivertTime(model)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StoretoDoorDeliveryWindow);
